import Vue from 'vue'
import Vuex from 'vuex'

import progress from './modules/progress'
import layout from './modules/layout'
import form from './modules/form'
import material from './modules/material'
import rand from './modules/rand'
import configuration from './modules/configuration'
import client from './modules/client'
import draft from './modules/draft'
import interfaceBackend from './modules/interfaceBackend'
import calc from './modules/calc'
import error from './modules/error'
import completion from './modules/completion'
import VAT from './modules/VAT'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    progress,
    layout,
    form,
    material,
    rand,
    configuration,
    client,
    draft,
    interfaceBackend,
    calc,
    error,
    completion,
    VAT
  }
})
